import { Card, Column, Modal, Row, Spacer } from '@components/1-atoms';
import React, { FC } from 'react';

import { TouchableOpacity } from 'react-native';

import Text from '@components/1-atoms/Text';
import ProductsServicesMenu from '@components/3-organisms/Menus/MenuProductsServices';

import useTheme from '@lib/theme';

import MenuIcon from '@assets/icons/plus';
import { PageProps } from '@lib/constants';

import { css } from '@emotion/native';

import ContactIllustration from "@assets/contact-illustration";
import EstimateIllustration from "@assets/estimate-illustration";
import InventoryIllustration from "@assets/inventory-illustration";




const theme = useTheme();
const icon = /* null; // */ <MenuIcon />;


type Props = Omit<PageProps, 'data' | 'currency'> & {};

const WidgetTODOs: FC<Props> = ({ navigation, ...props }) => {

    const [isModalInventoryVisible, setModalVisiblility] = React.useState(false);
    const openModalInventory = () => setModalVisiblility(true);
    const closeModalInventory = () => setModalVisiblility(false);

    return (
        <Card
            themed={true}
            title='TODO(S)'
        // icon={icon} // onAction={ openModal}
        >
            <Modal visible={isModalInventoryVisible} title={"Create an inventory"} onClose={closeModalInventory}>
                <ProductsServicesMenu navigation={navigation} />
            </Modal>

            {/* Create contact */}
            <TouchableOpacity onPress={() => navigation?.navigate('ContactCreate')}>
                {/* Description */}
                <Row>

                    {/* Illustration */}
                    <Column>
                        <ContactIllustration />
                    </Column>

                    <Column style={css`flex-grow: 4;`}>
                        <Text>Add my customers and suppliers information, and track my businesses with them.</Text>
                    </Column>
                </Row>
                <Spacer h={3} />

            </TouchableOpacity>

            {/* Create quote */}
            <TouchableOpacity onPress={() => openModalInventory()}>
                {/* Description */}
                <Row>

                    {/* Illustration */}
                    <Column>
                        <InventoryIllustration />
                    </Column>

                    <Column style={css`flex-grow: 4;`}>
                        <Text>Add the products and services I sell to my customers.</Text>
                    </Column>
                </Row>
                <Spacer h={3} />

            </TouchableOpacity>

            {/* Create estimate */}
            <TouchableOpacity onPress={() => navigation?.navigate('EstimateCreate')}>
                {/* Description */}
                <Row>

                    {/* Illustration */}
                    <Column>
                        <EstimateIllustration />
                    </Column>

                    <Column style={css`flex-grow: 4;`}>
                        <Text>Send a quote to a customer for the estimated costs of certain products and services s/he won't miss.</Text>
                    </Column>
                </Row>
                <Spacer h={3} />

            </TouchableOpacity>

        </Card>
    );
};

export default WidgetTODOs;